import { Dropdown } from 'react-bootstrap'

export interface ObjectRowActionsMenuItem {
  label: string
  icon: string
  onClick: () => void
  disabled?: boolean
  danger?: boolean
}

export interface ObjectRowActionsMenuProps {
  items: ObjectRowActionsMenuItem[]
}

export const ObjectRowActionsMenu: React.FC<ObjectRowActionsMenuProps> = ({ items }) => (
  <div onClick={(e) => e.stopPropagation()} className='pe-auto'>
    <Dropdown>
      <Dropdown.Toggle
        as='div'
        role='button'
        bsPrefix='p-0'
        className='d-flex align-items-center justify-content-center rounded zocks-bg-color-gray-200 zocks-text-gray-900 me-3'
      >
        <i className='bi bi-three-dots-vertical fs-5' />
      </Dropdown.Toggle>

      <Dropdown.Menu align='end'>
        {items.map((item) => (
          <Dropdown.Item key={item.label} onClick={item.onClick} disabled={item.disabled} className={`rounded${item.danger ? ' text-danger' : ''}`}>
            <i className={`bi ${item.icon} me-2`} /> {item.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  </div>
)
